import React from "react"
import LinkResolver from "../../utils/linkResolver"
import { Link } from "../atoms/Link"
import { Icon, SlatEl } from "./Slat"
import { graphql, useStaticQuery } from "gatsby"

export const WorkbookSlat = ({ workbook, first }) => {
  const linkUrl = LinkResolver(workbook.internal.type, workbook.slug)
  const { defaultIcon } = useStaticQuery(
    graphql`
      query {
        defaultIcon: contentfulAsset(title: { eq: "template-default-icon" }) {
          gatsbyImageData(layout: FIXED, height: 38, width: 38)
        }
      }
    `
  )

  let icon = null

  if (workbook.icon) {
    // if the template has an icon, we give this preference
    icon = workbook.icon.gatsbyImageData
  } else if (workbook.createdBy?.some(creator => creator.featuredImage)) {
    let i = 0
    // otherwise, we go to the creator and keep searching until we get an icon from the creator array
    while (!icon && i < workbook.createdBy.length) {
      icon = workbook.createdBy[i].featuredImage?.gatsbyImageData
      i++
    }
  } else {
    // if we still don't have an icon, let it be the default
    icon = defaultIcon.gatsbyImageData
  }

  return (
    <SlatEl first={first} id={workbook.contentfulId}>
      <Link to={linkUrl} tabindex="-1">
        <Icon image={icon} alt={`${workbook.title} icon`} />
      </Link>
      <div className={"main"}>
        <Link className={"link"} to={linkUrl}>
          <h1 className={"title"}>{workbook.title}</h1>
          <div className="quietWrapper">
            <div className="quiet">{workbook.description.description}</div>
          </div>
        </Link>
      </div>
    </SlatEl>
  )
}
